import { TranslateService } from "@ngstack/translate";
import { SnackBarService } from "src/app/services/common/snackBar.service";
import { Injectable } from "@angular/core";
import { SoundEnum } from "src/app/enums/sound.enum";
import * as moment from "jalali-moment";
import { IError } from "src/app/interfaces/error.interface";

@Injectable({
  providedIn: "root"
})
export class ErrorsService {
  // errors = new Array();
  // param = ["", "", "", ""];

  constructor(
    private snackBar: SnackBarService,
    public translate: TranslateService
  ) { }

  getError(error) {
    var errorNumber = new Array();
    var errors = error.error.ErrorData.Value.Errors;
    errors.forEach(element => {
      errorNumber.push(element.Message.split("|", 1));
    });
    return errorNumber;
  }

  objectError(errors) {
    var param = ["", "", "", ""];
    errors.forEach(element => {
      if (element.toString().includes("*")) {
        var params = element.toString().split("*");
        for (var z = 1; z <= params.length - 1; z++) {

          if (params[z] != '0' && Date.parse(params[z])) {
            param[z] = moment(params[z]).endOf('jDay').format('jYYYY/jM/jD');
          }
          else {
            param[z] = params[z];
          }
        }
      }
    });
    return param;
  }

  returnError(error) {
    var errorArray = new Array();
    var errorNumber = new Array();
    var errors = error.error.ErrorData.Value.Errors;
    errors.forEach(element => {
      errorNumber.push(element.Message.split("|", 1));
    });
    if (errorNumber.toString().includes("*")) {
      errorNumber.forEach(element => {
        errorArray.push(element.toString().split("*", 1));
        return errorArray;
      });
      return errorArray;
    } else {
      return errorNumber;
    }
  }

  getErrorList(e: any): IError[]
  {
    const errors = e.ErrorData.Value.Errors;
    const errorList: IError[] = [];

    errors.forEach((errorItem: any) => {
      const errorMesssage = errorItem.Message;
      const error = {
        code: +errorMesssage.split('|', 1)[0].split('*')[0],
        text: errorMesssage.includes('|') ? errorMesssage.split('|')[1] : errorMesssage
      }
      errorList.push(error);
    });
    
    return errorList;
  }

  transactionError() {
    this.snackBar.OpenSnackBar(
      this.translate.get("error.transaction"),
      "ok",
      5000,
      SoundEnum.beep
    );
  }

  recordHasBennUsed(err: any) {
    if (err && err.error && err.error.ErrorData) {
      var error = err.error.ErrorData.Value.Errors[0].Message;
      var errorCode = error.split("|");
      this.snackBar.OpenSnackBar(
        //this.translate.get("serviceErrors." + errorCode[0]),
        errorCode[1],
        "ok",
        5000,
        SoundEnum.beep
      );
    } else {
      this.transactionError();
    }
  }
}
